import { HttpClient } from "../../../services/http/http-client";
import { MODIFICATION_URL } from "../../../services/common-urls";
import { BOOKING_URL, CONTACTS_URL, CALENDAR_DATES_STRING } from "./booking-service";

const SECTION_BOOKING_PROMOTERS = 'promoter';

export const bookingPromotersService = {

    getBookingPromoters: (start) => {
        let params = {
            section: SECTION_BOOKING_PROMOTERS,
            action: 'promoter_page'
        };

        if (start) {
            params.start = start;
        }

        return HttpClient.get(BOOKING_URL, params);
    },

    deleteBookingPromoter: (promoterID) => {
        return HttpClient.post(BOOKING_URL, {
            section: SECTION_BOOKING_PROMOTERS,
            action: 'delete_promoter',
            promoter_id: promoterID
        });
    },

    getLoginLink: (promoterID, email) => {
        return HttpClient.post(BOOKING_URL, {
            section: SECTION_BOOKING_PROMOTERS,
            action: 'login_link',
            promoter_id: promoterID,
            email: email
        });
    },

    sendPermissionMail: (item) => {
        return HttpClient.post(BOOKING_URL, {
            section: SECTION_BOOKING_PROMOTERS,
            action: 'send_permission_mail',
            promoter_id: item.promoter_id,
            email: item.email,
            subject: item.subject,
            emailbody: item.emailbody
        });
    },

    searchPromoters: (searchKey) => {
        return HttpClient.post(BOOKING_URL, {
            section: SECTION_BOOKING_PROMOTERS,
            action: 'search_promoter',
            search: searchKey
        });
    },

    getContactsForPromoter: (start, options) => {
        let params = {
            section: SECTION_BOOKING_PROMOTERS,
            action: 'contact_for_promoter'
        };

        if (start) {
            params.start = start;
        }

        return HttpClient.post(BOOKING_URL, params, options);
    },

    searchContactForPromoter: (searchKey) => {
        return HttpClient.post(BOOKING_URL, {
            section: SECTION_BOOKING_PROMOTERS,
            action: 'search_contacts_json',
            search: searchKey
        });
    },

    matchedPromoters: (contactID) => {
        return HttpClient.post(BOOKING_URL, {
            section: SECTION_BOOKING_PROMOTERS,
            action: 'matched_promoter_list',
            contact_id: contactID
        });
    },

    linkPromoter: (contactID, promoterID) => {
        return HttpClient.post(BOOKING_URL, {
            section: SECTION_BOOKING_PROMOTERS,
            action: 'link_promoter',
            promoter_id: promoterID,
            contact_id: contactID
        });
    },

    addContactAsNewPromoter: (contactID) => {
        return HttpClient.post(BOOKING_URL, {
            section: SECTION_BOOKING_PROMOTERS,
            action: 'add_contact_as_new_promoter',
            contact_id: contactID
        });
    },

    getBookingPromoterTab: (tab, promoterID) => {
        let action = '';
        switch (tab) {
            case 'bookings':
                action = 'promoter_details_tab_bookings';
                break;

            case 'additional_info':
                action = 'promoter_details_tab_additional_info';
                break;

            default:
                action = 'promoter_details_tab_overview';
        }

        return HttpClient.get(BOOKING_URL, {
            section: SECTION_BOOKING_PROMOTERS,
            action: action,
            promoter_id: promoterID
        });

    },

    modify_contact_relations: (id, columnName, columnNewValue) => {
        HttpClient.modify('contact_relation_id', id, columnName, columnNewValue, 'contact_relations');
    },

    modify_contacts: (id, columnName, columnNewValue) => {
        HttpClient.modify('contact_id', id, columnName, columnNewValue, 'contacts');
    },

    updateContactVatNo: (contactID, VatNo) => {
        return HttpClient.post(CONTACTS_URL, {
            section: "",
            action: "update_vat_no",
            contact_id: contactID,
            vat_no: VatNo
        });
    },

    checkContactVatIdUpdateFlag: (contactID, VatNo) => {
        return HttpClient.post(CONTACTS_URL, {
            section: "",
            action: "check_vat_id_update_flag",
            contact_id: contactID,
            vat_no: VatNo,
            type: 'promoter'
        });
    },

    addPromoterComment: (promoterID, comment) => {
        return HttpClient.post(BOOKING_URL, {
            section: SECTION_BOOKING_PROMOTERS,
            action: "new_comment",
            status: "public",
            table_id: promoterID,
            comment: comment
        });
    },

    getPromoterComment: (promoterID) => {
        return HttpClient.get(BOOKING_URL, {
            section: SECTION_BOOKING_PROMOTERS,
            action: "load_comments",
            status: "public",
            table_id: promoterID
        });
    },

    deletePromoterComment: (commentID) => {
        return HttpClient.post(BOOKING_URL, {
            section: SECTION_BOOKING_PROMOTERS,
            action: "delete_comment",
            comment_id: commentID
        });
    },

    getPromoterBookings: (promoterID) => {
        return HttpClient.get(BOOKING_URL, {
            section: SECTION_BOOKING_PROMOTERS,
            action: "promoter_details_tab_bookings",
            promoter_id: promoterID
        });
    },

};
